import type { ComponentProps } from "react";

import { cn } from "@/lib/utils";

export default function Textarea({
  className,
  ...props
}: ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "bg-background-neutral border-background-neutral-hovered placeholder:text-foreground-pressed text-foreground interactive flex field-sizing-content min-h-16 w-full rounded-md border px-3 py-2 text-sm shadow-xs",
        "aria-invalid:ring-critical/20 aria-invalid:border-critical",
        className,
      )}
      {...props}
    />
  );
}
